exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".number-with-bg{width:330px;height:80px}.number-with-bg .left{float:left;width:90px;color:#fff;font-size:20px;line-height:30px;height:100%;overflow:hidden;padding-top:8px;box-sizing:border-box}.number-with-bg .right{float:left;width:250px;height:100%;color:#ffc003;font-size:36px;text-align:center;line-height:88px;background-image:url(" + require("./mesh-bg.svg") + ");background-size:cover;margin-left:-20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-25870328!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/fragment/number-with-bg/index.vue
// module id = 164
// module chunks = 0